import {
  BUSINESS_OWNER_GROUP_NAME,
  BUSINESS_OWNER_PROFESSIONAL_GROUP_NAME,
  BUSINESS_MEMBER_GROUP_NAME,
  CHOWNOW_SALES_GROUP_NAME,
  CHOWNOW_SALES_ADMIN_GROUP_NAME,
  EZCATER_SALES_GROUP_NAME,
  CLOVER_SALES_GROUP_NAME,
  BBOT_SALES_GROUP_NAME,
  BBOT_SALES_ADMIN_GROUP_NAME,
  TOAST_SALES_GROUP_NAME,
  TOAST_SALES_ADMIN_GROUP_NAME,
  ZUPPLER_SALES_GROUP_NAME,
  ZUPPLER_SALES_ADMIN_GROUP_NAME,
  DAY_SMART_SALES_GROUP_NAME,
  DAY_SMART_SALES_ADMIN_GROUP_NAME,
} from './auth';
import { isAdminUser, isUserInGroup } from '../libs/auth';

const groupNameToGroupDisplay = {
  [BUSINESS_OWNER_GROUP_NAME]: 'Business Owner',
  [BUSINESS_OWNER_PROFESSIONAL_GROUP_NAME]: 'Business Owner Professional',
  [BUSINESS_MEMBER_GROUP_NAME]: 'Business Member',
  [CHOWNOW_SALES_GROUP_NAME]: 'ChowNow Rep',
  [CHOWNOW_SALES_ADMIN_GROUP_NAME]: 'ChowNow Rep Admin',
  [EZCATER_SALES_GROUP_NAME]: 'ezCater Rep',
  [CLOVER_SALES_GROUP_NAME]: 'Clover Rep',
  [BBOT_SALES_GROUP_NAME]: 'BBot Rep',
  [BBOT_SALES_ADMIN_GROUP_NAME]: 'BBot Rep Admin',
  [TOAST_SALES_GROUP_NAME]: 'Toast Rep',
  [TOAST_SALES_ADMIN_GROUP_NAME]: 'Toast Rep Admin',
  [ZUPPLER_SALES_GROUP_NAME]: 'Zuppler Rep',
  [ZUPPLER_SALES_ADMIN_GROUP_NAME]: 'Zuppler Rep Admin',
  [DAY_SMART_SALES_GROUP_NAME]: 'DaySmart Rep',
  [DAY_SMART_SALES_ADMIN_GROUP_NAME]: 'DaySmart Rep Admin',
};

const defaultGroups = [BUSINESS_MEMBER_GROUP_NAME, BUSINESS_OWNER_GROUP_NAME];

const getUserGroups = (user) => {
  return Object.keys(groupNameToGroupDisplay).filter(
    (groupName) => isAdminUser(user) || isUserInGroup(user, groupName),
  );
};

const getUserGroupsForOptions = (user) => {
  return [...new Set([...defaultGroups, ...getUserGroups(user)])];
};

const getUserGroupOptions = (user) => {
  return getUserGroupsForOptions(user).map((role) => ({
    key: role,
    value: role,
    text: groupNameToGroupDisplay[role],
  }));
};

export { groupNameToGroupDisplay, getUserGroupOptions, getUserGroups };
